// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const alert = "Alert__alert__NXQ4O";
export const danger = "Alert__danger__lKQ1+";
export const warning = "Alert__warning__pGwHB";
export const success = "Alert__success__cTVBW";
export const action = "Alert__action__+Er60";
export const content = "Alert__content__Uwdu8";